import { Injectable } from '@angular/core';

import { CustomToastComponent } from '@/ui/elements/custom-toast/custom-toast.component';

import {Toast} from '@/ui/elements/custom-toast/custom-toast.types';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastSubject = new Subject<Toast>();
  public toast$ = this.toastSubject.asObservable();
  private toastIdCounter = 0;


  private emitToast(
    title: string,
    message: string,
    type: Toast['type'] = 'info',
    headerType: Toast['headerType'] = 'info',
    autoHide = true,
    delay = 5000
  ) {
    const toast: Toast = {
      id: ++this.toastIdCounter,
      title,
      message,
      type,
      headerType,
      autoHide,
      delay,
      time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
    };
    this.toastSubject.next(toast);
  }

  showToast(
    title: string,
    message: string,
    type: Toast['type'] = 'info',
    headerType: Toast['headerType'] = 'info',
    autoHide = true,
    delay = 5000
  ) {
    this.emitToast(title, message, type, headerType, autoHide, delay);
  }
}
